if (!customElements.get('iyi-dawn-tabs')) {
  customElements.define('iyi-dawn-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.addEventListener('click', event => {
        const tab = event.target.closest('[role="tab"]');
        if (this.tabs.includes(tab)) this.select(tab);
      });
      this.addEventListener('keydown', event => {
        if (!this.tabs.includes(event.target)) return;
        const index = this.tabs.indexOf(event.target);
        const keys = { ArrowRight: (index + 1) % this.tabs.length, ArrowLeft: (index + this.tabs.length - 1) % this.tabs.length, Home: 0, End: this.tabs.length - 1 };
        if (!(event.key in keys)) return;
        event.preventDefault();
        this.select(this.tabs[keys[event.key]]);
        this.tabs[keys[event.key]].focus();
      });
    }
    select(selected) {
      this.tabs.forEach(tab => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      });
    }
  });
}
if (!customElements.get('iyi-dawn-packages')) {
  customElements.define('iyi-dawn-packages', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const root = document.getElementById('shopify-section-' + this.dataset.section);
      const input = root?.querySelector('input[name="quantity"]');
      if (!input) return;
      const buttons = [...this.querySelectorAll('[data-quantity]')];
      const sync = () => buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.quantity === input.value)));
      const selected = buttons.find(button => button.getAttribute('aria-pressed') === 'true');
      if (selected) input.value = selected.dataset.quantity;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-quantity]');
        if (!buttons.includes(button)) return;
        input.value = button.dataset.quantity;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      });
      input.addEventListener('change', sync, { signal: (this.abort = new AbortController()).signal });
      sync();
    }
    disconnectedCallback() { this.abort?.abort(); this.ready = false; }
  });
}
if (!customElements.get('iyi-dawn-track')) {
  let trackingLibrary;
  const loadTracking = () => trackingLibrary ||= new Promise((resolve, reject) => {
    if (window.YQV5) return resolve();
    const script = document.createElement('script');
    script.src = 'https://www.17track.net/externalcall.js';
    script.onload = resolve;
    script.onerror = () => { trackingLibrary = undefined; reject(new Error('tracking')); };
    document.head.append(script);
  });
  customElements.define('iyi-dawn-track', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('submit', async event => {
        event.preventDefault();
        const form = event.target;
        const button = form.querySelector('button');
        const message = form.querySelector('[role="status"]');
        button.disabled = true;
        message.hidden = true;
        try {
          await loadTracking();
          window.YQV5.trackSingle({ YQ_ContainerId: this.querySelector('[data-track-result]').id, YQ_Height: 560, YQ_Fc: '0', YQ_Lang: document.documentElement.lang, YQ_Num: form.elements.tracking.value.trim() });
        } catch {
          message.textContent = 'Takip bilgisi şu anda yüklenemiyor. Lütfen tekrar deneyin.';
          message.hidden = false;
        } finally { button.disabled = false; }
      });
    }
  });
}
if (!customElements.get('iyi-dawn-popup')) {
  customElements.define('iyi-dawn-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog');
      if (!dialog) return;
      const key = 'iyi-dawn-newsletter-dismissed';
      let dismissed = 0;
      try { dismissed = Number(localStorage.getItem(key)) || 0; } catch {}
      const shouldOpen = this.querySelector('[data-popup-success]') || location.hash.includes('IyiPopup-') || this.dataset.mode === 'testing' || Date.now() - dismissed > Number(this.dataset.days) * 86400000;
      if (shouldOpen) this.timer = setTimeout(() => { if (dialog.isConnected && !dialog.open) dialog.showModal(); }, this.querySelector('[data-popup-success]') ? 0 : Number(this.dataset.delay) * 1000);
      const dismiss = () => { dialog.close(); try { localStorage.setItem(key, String(Date.now())); } catch {} };
      this.addEventListener('click', async event => {
        if (event.target.closest('[data-popup-close]')) dismiss();
        const copy = event.target.closest('[data-popup-copy]');
        if (!copy) return;
        const message = this.querySelector('[role="status"]');
        try {
          await navigator.clipboard.writeText(this.querySelector('input[readonly]').value);
          message.textContent = copy.dataset.copied;
        } catch { message.textContent = 'Kodu seçerek kopyalayabilirsiniz.'; }
        message.hidden = false;
      });
      dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
      dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dismiss(); } });
    }
    disconnectedCallback() { clearTimeout(this.timer); this.ready = false; }
  });
}
const syncIyiTopButtons = () => document.querySelectorAll('[data-iyi-to-top]').forEach(button => { button.hidden = scrollY < Number(button.dataset.after); });
addEventListener('scroll', syncIyiTopButtons, { passive: true });
document.addEventListener('DOMContentLoaded', syncIyiTopButtons, { once: true });
document.addEventListener('click', event => { if (event.target.closest('[data-iyi-to-top]')) scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); });
